export const UPI_INTENT_METHOD_TYPE = {
    PREFERRED: "preferred",
    NON_PREFERRED: "non-preferred",
};
